import { useAuth } from './use-auth';
import { useGetAllUsers } from './useGetAllUsers';
import { useKFlags } from './use-k-flags';

export const useGetDefaultFrom = ({
  fromKey = 'email',
  enableMailFromLaunchDarkly = true,
}) => {
  const { currUser } = useAuth();
  const { feDefaultRejectEmail } = useKFlags();
  const { fromUsers, sharedEmails } = useGetAllUsers();

  let from = undefined;
  let fromUserObject = undefined;

  const defaultRejectEmailFromLaunchDarkly = feDefaultRejectEmail
    ? fromUsers.find((user) => user?.[fromKey] === feDefaultRejectEmail)
    : false;

  const defaultSharedEmailUser =
    sharedEmails?.find((user) => user.is_default) || undefined;

  // if the default reject email is set in launchdarkly, use that
  if (defaultRejectEmailFromLaunchDarkly && enableMailFromLaunchDarkly) {
    from = feDefaultRejectEmail;
    fromUserObject = defaultRejectEmailFromLaunchDarkly;
    // if the default shared email is set, use that
  } else if (defaultSharedEmailUser) {
    from = defaultSharedEmailUser?.[fromKey];
    fromUserObject = defaultSharedEmailUser;
    // if the current user is set, use that
  } else if (currUser?.email) {
    from = currUser.email;
    fromUserObject = currUser;
  }

  return { from, fromUserObject };
};
